export default __webpack_public_path__ + "static/media/2FVISUAL_cgi.53f79606.png";